import axios from "axios";

const Url = process.env.REACT_APP_URl;
const UrlDev = process.env.REACT_APP_URl;

export const InviteUser = async (user: any) => {
  const apiUrl = UrlDev + "/users";
  const response = await axios.post(apiUrl, user, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const getusers = async () => {
  const apiUrl = UrlDev + "/allusers";
  const response = await axios.get(`${apiUrl}/${localStorage.getItem('id')}`, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const ChangePasswordService = async (formData: any) => {
  const apiUrl = Url + "/change_password";
  const response = await axios.put(apiUrl, formData, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const DropUser = async (id: any) => {
  const apiUrl = Url + "/users";
  const response = await axios.delete(`${apiUrl}/${id}`, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}


export const UpdateUser = (user: any) => {
  const apiUrl = UrlDev + "/users";
  return axios.put(`${apiUrl}/${user._id}`, user, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  }).then((response) => {
    return response.data;
  })

}
export const acceptInvit = async (user: any, id: any) => {
  const apiUrl = UrlDev + "/users";
  const response = await axios.put(`${apiUrl}/${id}`, user, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

